export class EventUtils {

  public static isLeftButtonDown(e: MouseEvent){
    const leftButton = 0;
    return leftButton === (e.button ?? 0);
  }
}
